import { BusinessPartner } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 0450. 取引先登録
 * [POST] /workspaces/:identifier/business_partners
 */
type Props = {
  identifier: string;
  name: string;
  display_name: string;
  description: string;
  business_partner_context_id: number;
  corporate_number: string;
  display_type: 'both' | 'sales' | 'purchase';
};

const createBusinessPartner = (props: Props): Promise<BusinessPartner> => {
  return axios.post(`/api/workspaces/${props.identifier}/business_partners`, props);
};

export const useCreateBusinessPartner = () => {
  return useMutation({
    mutationFn: createBusinessPartner,
  });
};
